var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1684 8.81478C20.3807 8.60237 20.5 8.31431 20.5 8.01396C20.5 7.7136 20.3807 7.42555 20.1684 7.21313L13.7606 0.805397C13.6561 0.697212 13.5311 0.61092 13.393 0.551556C13.2548 0.492191 13.1061 0.460944 12.9557 0.459637C12.8053 0.45833 12.6562 0.48699 12.517 0.543944C12.3778 0.600897 12.2513 0.685004 12.1449 0.791357C12.0386 0.897711 11.9545 1.02418 11.8975 1.16339C11.8406 1.30259 11.8119 1.45175 11.8132 1.60215C11.8145 1.75255 11.8458 1.90118 11.9051 2.03938C11.9645 2.17757 12.0508 2.30256 12.159 2.40705L16.6332 6.88125L1.63271 6.88125C1.33229 6.88125 1.04419 7.00059 0.83176 7.21301C0.619337 7.42543 0.5 7.71354 0.5 8.01396C0.5 8.31437 0.619337 8.60248 0.83176 8.8149C1.04419 9.02733 1.33229 9.14667 1.63271 9.14667L16.6332 9.14667L12.159 13.6209C11.9526 13.8345 11.8385 14.1206 11.8411 14.4176C11.8436 14.7146 11.9628 14.9987 12.1728 15.2087C12.3828 15.4187 12.6669 15.5379 12.9639 15.5404C13.2609 15.543 13.547 15.4289 13.7606 15.2225L20.1684 8.81478Z",
    fill: "#F09000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bdb36301.svg";
export { ForwardRef as ReactComponent };